/* eslint-disable tss-unused-classes/unused-classes */

import React from 'react';
import { makeStyles } from 'tss-react/mui';

import type { institutionsTypes } from 'app-components/flux/institutions';

import bankIcon from 'app-components/assets/QIllustration/FiBuilding.svg';

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  containerForButtonStyle: {
    height: '64px',
    width: '102px',
    borderRadius: '6px',
  },
  // used with {size}ContainerStyle
  mdContainerForIconStyle: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 16,
    height: '64px',
    width: '64px',
  },
  // used with {size}ContainerStyle
  smContainerForIconStyle: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 12,
    height: '48px',
    width: '48px',
  },
  xsContainerForIconStyle: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 10,
    height: '42px',
    width: '42px',
  },
  genericImageButtonStyle: {
    backgroundColor: theme.palette.background.layer1,
    border: '1px solid rgba(151,151,151,0.4)',
  },
  img: {
    backgroundColor: '#FFFFFF',
    width: '100%',
    minHeight: '1px',
  },
  round: {
    borderRadius: '50%',
  },
}));

export function MacroCaseToPascalCase(string: string) {
  let result = '';

  const words = string.toLowerCase().split('_');
  for (let i = 0; i < words.length; i++) {
    result += words[i][0].toUpperCase() + words[i].substring(1);
  }

  return result;
}

type sizeOptions = 'md' | 'sm' | 'xs';

interface InstitutionIconProps {
  institution?: institutionsTypes.Institution | null;
  size?: sizeOptions;
  sizePixels?: number;
  square?: boolean;
}

const InstitutionIcon = ({ institution, size = 'md', sizePixels, square }: InstitutionIconProps) => {
  const { classes, cx } = useStyles();

  let iconSrc;
  let iconAltName;

  const iconClassNames: string[] = [];

  if (institution?.logoUrl) {
    iconSrc = institution.logoUrl;
    iconAltName = institution.name;
  } else if (institution?.logo) {
    iconSrc = `data:image/svg;base64, ${institution.logo}`;
    iconAltName = institution.name;
  } else {
    iconSrc = bankIcon;
    iconClassNames.push(classes.genericImageButtonStyle);
    iconAltName = institution?.name || 'Generic Bank Icon';
  }
  if (institution?.logoStyle === 'BUTTON') {
    iconClassNames.push(classes.containerForButtonStyle);
  } else {
    iconClassNames.push(classes[`${size}ContainerForIconStyle`]);
    if (!square) {
      iconClassNames.push(classes.round);
    }
  }

  return (
    <div
      className={cx(classes.container, iconClassNames)}
      style={sizePixels ? { height: sizePixels, width: sizePixels } : undefined}
    >
      <img alt={iconAltName} src={iconSrc} className={classes.img} />
    </div>
  );
};

export const InstitutionIconSize = (institution?: institutionsTypes.Institution, size: sizeOptions = 'md') => {
  if (institution?.logoStyle === 'BUTTON') {
    return { height: 64, width: 102 };
  }
  return size === 'sm' ? { height: 48, width: 48 } : { height: 64, width: 64 };
};

export default InstitutionIcon;
